import React from "react";

import Menu from "../../../templates/menu-template";

const itens: any = [
  {
    key: 1,
    icon: "home",
    title: "Home",
    route: ["/admin/home"],
  },
  {
    key: 2,
    icon: "user",
    title: "Novas Solicitações",
    route: ["/admin/solicitations"],
  },
  {
    key: 3,
    icon: "users",
    title: "Todos os usuários",
    route: ["/admin/developers"],
  },
];

const MenuAdmin: React.FC = (): JSX.Element => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = (): void => setIsMenuOpen(!isMenuOpen);

  return <Menu itens={itens} isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />;
};
export default MenuAdmin;
